import * as yup from 'yup'
import { ValidationError } from 'yup'

const QUANTITY_PATH = 'cardQuantity'

const ValidateQuantitySchema = (minQuantity: number, maxQuantity: number) => {
    return yup.object({
        cardQuantity: yup
            .number()
            .label('Card quantity')
            .test(
                'quantityValueLegit',
                `Card quantity must be between ${minQuantity} and ${maxQuantity}`,
                (value: number | undefined) => {
                    if (!value) return false
                    return minQuantity <= value && value <= maxQuantity
                }
            ),
    })
}

// set card quantity and validate it is valid
export function validateCardQuantity(
    quantity: number,
    setQuantity: Function,
    formErrors: ValidationError[],
    setFormErrors: Function,
    minQuantity: number,
    maxQuantity: number
) {
    setQuantity(quantity)

    const existingQuantityError = formErrors?.find(
        (error) => error.path === QUANTITY_PATH
    )

    ValidateQuantitySchema(minQuantity, maxQuantity)
        .validate({
            cardQuantity: quantity,
        })
        .then(() => {
            if (!existingQuantityError) {
                return
            }

            const nonQuantityErrors =
                formErrors?.filter((error) => error.path !== QUANTITY_PATH) ??
                []

            setFormErrors(nonQuantityErrors)
        })
        .catch((err: ValidationError) => {
            if (!existingQuantityError) {
                setFormErrors((prev: ValidationError[]) => {
                    let array = [...prev]
                    array.push(err)
                    return array
                })
            }
        })
}
